import { createAction, props } from '@ngrx/store';
import { Estado, EstadoForm } from '@core/models'
import { ResponseBadRequest } from '@core/interfaces';

export const STATE_FIND = createAction('[State] Find', props<{ id: string }>());
export const STATE_FIND_ALL = createAction('[State] Find All');

export const STATE_FIND_SUCCESS = createAction('[State] Find Success', props<{ stateData: Estado }>());
export const STATE_FIND_ALL_SUCCESS = createAction('[State] Find All Success', props<{ stateList: Estado[] }>());

export const STATE_FAILURE = createAction('[State] Failure', props<{ error: ResponseBadRequest }>());

export const STATE_UPDATE_LOADING = createAction('[State] Update Loading', props<{ loading: boolean }>());
export const STATE_UPDATE_FORM = createAction('[State] Update Form', props<{ stateForm: EstadoForm }>());
export const STATE_EDIT_MODE = createAction('[State] Edit Mode', props<{ editMode: boolean }>());

export const STATE_RESET = createAction('[State] Reset');
export const STATE_RESET_FORM = createAction('[State] Reset Form');
export const STATE_RESET_ERROR = createAction('[State] Reset Error');
export const STATE_CLEAR_STATE = createAction('[State] Clear State');